var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramSpeech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 28,
    viewBox: "0 0 200 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_16600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3018 25.6129L0 18.9377L7.76494 13.99L0 9.04233L10.3018 2.36719L11.8661 4.79076L5.33615 9.0217L13.1345 13.99L5.33615 18.9583L11.8661 23.1893L10.3018 25.6129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8647 25.6129L8.56543 18.9377L16.3304 13.99L8.56543 9.04233L18.8647 2.36719L20.429 4.79076L13.9016 9.0217L21.7 13.99L13.9016 18.9583L20.429 23.1893L18.8647 25.6129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.659 1.6084H184.501V26.3881H188.659V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.998 1.6084H195.84V26.3881H199.998V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.666 11.2233L185.912 15.2422L187.255 19.1854L199.009 15.1665L197.666 11.2233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.481 1.6084H57.3232V26.3881H61.481V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8199 1.6084H68.6621V26.3881H72.8199V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4834 11.2203L58.7295 15.2393L60.0721 19.1825L71.826 15.1636L70.4834 11.2203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.539 27.0845H119.381V0.915039L135.145 9.66053L123.585 21.848L123.539 21.8042V27.0845ZM123.539 7.98465V15.8458L128.425 10.6944L123.539 7.98465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.892 27.3761L103.332 24.0889L109.213 19.4918L101.821 10.4575L111.423 0.624023L114.395 3.53747L107.399 10.7025L115.128 20.1493L105.892 27.3761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5894 1.63965H37.9678V5.80613H52.5894V1.63965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.356 3.72266H43.1982V26.3573H47.356V3.72266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.806 28L165.819 13.1466L174.974 0L178.383 2.3849L170.942 13.0744L180.145 25.5171L176.806 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.129 28L135.146 13.1466L144.297 0L147.709 2.3849L140.266 13.0744L149.471 25.5171L146.129 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.801 11.0273H137.705V15.1938H147.801V11.0273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.428 28L150.441 13.1466L159.596 0L163.005 2.3849L155.564 13.0744L164.767 25.5171L161.428 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.097 11.0273H153.001V15.1938H163.097V11.0273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5467 28L75.5605 13.1466L84.7148 0L88.1239 2.3849L80.6831 13.0744L89.8863 25.5171L86.5467 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.219 11.0273H78.123V15.1938H88.219V11.0273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_16600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramSpeech);
export default __webpack_public_path__ + "static/media/programSpeech.d7fec3dcbac3e811aafa0c6d63cb235c.svg";
export { ForwardRef as ReactComponent };